// ScrollTopRoot.tsx
import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function ScrollTopRoot() {
  const { pathname, hash } = useLocation();
  const topRef = useRef<HTMLSpanElement>(null);

  // disattiva la scroll restoration del browser
  useLayoutEffect(() => {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }, []);

  // scroll to top e focus al sentinella ad ogni cambio di rotta
  useLayoutEffect(() => {
    // niente smooth per evitare “rimbalzi”
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;

    const origFocus = HTMLElement.prototype.focus;
    let block = true;

    // scrolla subito in alto
    window.scrollTo(0, 0);

    // metti il focus in alto (senza scroll)
    topRef.current?.focus({ preventScroll: true });

    // se c'è un hash, priorità subito dopo
    if (hash) {
      requestAnimationFrame(() => {
        const id = decodeURIComponent(hash.slice(1));
        document.getElementById(id)?.scrollIntoView({ block: "start" });
      });
    }

    HTMLElement.prototype.focus = function (options?: any) {
      if (block) return; // ignora i focus
      return origFocus.call(this, options);
    };

    const timer = setTimeout(() => (block = false), 1000); // 1s di blocco

    return () => {
      html.style.scrollBehavior = prev;
      clearTimeout(timer);
      HTMLElement.prototype.focus = origFocus;
    };
  }, [pathname, hash]);

  return (
    <span
      ref={topRef}
      id="top-sentinel"
      tabIndex={-1}
      style={{
        position: "absolute",
        inset: 0,
        width: 0,
        height: 0,
        outline: "none",
      }}
    />
  );
}
